import React, { useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import Google from '../assets/images/google.png';
import Apple from '../assets/images/apple_white.png';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
// import MenuItem from './components/MenuItem';
import PageLoader from '../components/PageLoader';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import _ from 'lodash';

import '../App.css';
// import API from '../module/api-client';
import Auth from '../core/services/auth';
import { useNavigate } from 'react-router-dom';
// import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useScript, appleAuthHelpers } from 'react-apple-signin-auth';

function Login() {
    // aple sign in
    useScript(appleAuthHelpers.APPLE_SCRIPT_SRC);
    // navigate to Login
    const navigate = useNavigate();
    const { state } = useLocation();
    
    //
    if (Auth.isAuthenticated()) {
      navigate('/')
    }

    // auth user
    // useEffect(()=> {
      
    //   Auth.authUser().then(res=> {
    //     navigate('/')
        
    //   }).catch(err=>{
    //     console.log(err.message)
    //   })
    // })

    const [ email, setEmail ] = useState('')
    const [ password, setPassword ] = useState('')
    const [ emailError ] = useState('')
    const [ passwordError ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const [ submit, submitType ] = useState('')
    const [ openTerms, setOpenTerms ] = useState(false)
    const [ passwordType, setPasswordType ] = useState('password')

    const handleSubmit = async (event: any) => {
      // prevent page from refreshing
      event.preventDefault();

      // Set Loader
      setLoading(true)

      //  set form data
      const formData = {
        email: email,
        password: password
      }

      // init ajax
      if (submit === 'login') {

        Auth.login(formData).then(res => {
          setLoading(false)

          console.log(res.data)

          // set Token & User
          Auth.setToken(res.data.token);
          Auth.setRefreshToken(res.data.refresh)

          //  get user profile
          Auth.authUser().then(res => {
            //
            Auth.setUser(res.data.data.user)
            //
            const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
            //
            for (let index = 0; index < vendors.length; index++) {
              const vendor = vendors[index];
              Auth.setVendor(vendor)
            }
            
          })

          // check for vendor admin request after login
          if (state) {
            //
            navigate('/'+state.page+'/'+state.id)
          }
          else {
            // navigate 
            navigate('/')

          }
  
          // toast.success(data, {
          //   position: "top-center",
          // });

        }).catch(err=>{
  
          console.log(err)
  
          setLoading(false)

          if (_.isArray(err.response.data.error)) {
            let error = err.response.data.error
            //
            for (let index = 0; index < error.length; index++) {
              const err = error[index];
              toast.error(err.message, {
                position: "top-center",
              });
            }
          } else {
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
          }
  
        })
      
      }
      
      else if (submit === 'signup') {

        Auth.createAccount(formData).then(res=> {
          
          setLoading(false)

          console.log(res)

          // set Token & User
          Auth.setToken(res.data.data.token);
          Auth.setRefreshToken(res.data.data.refresh)
          // Auth.setUser(res.data.data.user)

          //  get user profile
          Auth.authUser().then(res => {
            //
            Auth.setUser(res.data.data.user)
            //
            const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
            //
            for (let index = 0; index < vendors.length; index++) {
              const vendor = vendors[index];
              Auth.setVendor(vendor)
            }
            
          })

          // navigate 
          navigate('/setup')
  
          // toast.success(res.data, {
          //   position: "top-center",
          // });
          
        }).catch(err=>{
  
          console.log(err.response)
  
          setLoading(false)
  
          if (_.isArray(err.response.data.error)) {
            let error = err.response.data.error
            //
            for (let index = 0; index < error.length; index++) {
              const err = error[index];
              toast.error(err.message, {
                position: "top-center",
              });
            }
          } else {
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
          }
  
        })
      }
      
    }

    const googleLogin = useGoogleLogin({
        onSuccess: (credentialResponse: any) => handleLogin (credentialResponse),
        onError: (error) => { console.log('Login Failed', error) }
    })

    const handleLogin = async (credentialResponse: { credential?: any; }) => {
      // console.log(credentialResponse)
      // const obj = jwtDecode(credentialResponse.credential);
      // const ldata = JSON.stringify(obj);
      // console.log(ldata);

      // return;

      Auth.googleLogin({ googleToken: credentialResponse.credential}).then(res => {
        setLoading(true)

        // console.log(res.data)

        // set Token & User
        Auth.setToken(res.data.token);
        Auth.setRefreshToken(res.data.refresh)

        //  get user profile
        Auth.authUser().then(res => {
          //
          Auth.setUser(res.data.data.user)
          //
          const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
          //
          for (let index = 0; index < vendors.length; index++) {
            const vendor = vendors[index];
            Auth.setVendor(vendor)
          }
          
        })

        // navigate 
        navigate('/')

        // toast.success(data, {
        //   position: "top-center",
        // });

      }).catch(err=>{

        console.log(err)

        setLoading(false)

        if (_.isArray(err.response.data.error)) {
          let error = err.response.data.error
          //
          for (let index = 0; index < error.length; index++) {
            const err = error[index];
            toast.error(err.message, {
              position: "top-center",
            });
          }
        } else {
          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            position: "top-center",
          });
        }
      })
    }

    const viewPassword = () => {
      //
      if (passwordType === 'password') {
        //
        setPasswordType('text')
      } else {
        setPasswordType('password')
      }
    }
    
    const appleLogin  = () => appleAuthHelpers.signIn({
      authOptions: {
        /** Client ID - eg: 'com.example.com'  AHLP9QDDG7*/ 
        clientId: 'app.wherespoppin.wherespoppin',
        /** Requested scopes, seperated by spaces - eg: 'email name' */
        scope: 'name email',
        /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
        redirectURI: 'https://wherespoppin.app',
        /** State string that is returned with the apple response */
        state: 'state',
        /** Nonce */
        nonce: 'nonce',
        // response_mode: form_post,
        /** Uses popup auth instead of redirection */
        usePopup: true
      },
      onSuccess: (response: any) => handleApple(response),
      onError: (error: any) => { console.log('Login Failed', error) },
    })

    
    const handleApple = async (credentialResponse: any) => {
      // console.log(credentialResponse)
      // const obj = jwtDecode(credentialResponse.credential);
      // const ldata = JSON.stringify(obj);
      // console.log(ldata);

      // return;

      Auth.appleLogin(credentialResponse).then(res => {
        setLoading(true)

        // console.log(res.data)

        // set Token & User
        Auth.setToken(res.data.token);
        Auth.setRefreshToken(res.data.refresh)

        //  get user profile
        Auth.authUser().then(res => {
          //
          Auth.setUser(res.data.data.user)
          //
          const vendors = res.data.data.vendorAdmins.map(({ vendor }: any) => vendor)
          //
          for (let index = 0; index < vendors.length; index++) {
            const vendor = vendors[index];
            Auth.setVendor(vendor)
          }
          
        })

        // navigate 
        navigate('/')

        // toast.success(data, {
        //   position: "top-center",
        // });

      }).catch(err=>{

        console.log(err)

        setLoading(false)

        if (_.isArray(err.response.data.error)) {
          let error = err.response.data.error
          //
          for (let index = 0; index < error.length; index++) {
            const err = error[index];
            toast.error(err.message, {
              position: "top-center",
            });
          }
        } else {
          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            position: "top-center",
          });
        }

      })
    }
      // const config = {
      //   method: 'POST',
      //   url: 'your backend server or endpoint',
      //   headers: {},
      //   data: data
      // }
      
      // console.log('submitted');

      // if (!/\S+@\S+\.\S+/.test(email)) {
      //   setEmailError("Please enter your email")

      //   return
      // }

      // if ('' === password) {
      //   setPasswordError('Please enter a password')

      //   return
      // }

      // if (password.length < 7) {
      //   setPasswordError('password must be 8 characters or longer')

      //   return
      // }

      // e.preventDefault()

      // setTimeout(()=> {
      //   setLoading(false)
      // }, 1800)
  
  
    

    return (
        <section className="pt-2">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-screen md:h-screen lg:py-0">
            
            { loading ? <PageLoader /> : '' }
            <ToastContainer />
            <AppLogo/>
            <AppTitle title={'WheresPoppin'} description={'Discover places & events'} />
            
            <div className="w-full md:mt-0 sm:max-w-md xl:p-0">
              <div className="p- space-y-4 md:space-y-6 sm:p-8">
                  {/* <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                      Sign in to your account
                  </h1> */}
                  
                  <form className="space-y-4 md:space-y-5" onSubmit={handleSubmit}>
                      <div>
                          <input type="text" name="email" id="email" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setEmail(e.target.value) } placeholder="Email / Username" value={email} required={true}/>
                          <label className='text-left'>{emailError}</label>
                      </div>
                      <div className="relative">

                          <div style={{width:'10px', float: 'right'}} className=" absolute pt-5 right-6">
                            <button type="button" onClick={e=>viewPassword()} className="items-center">
                              <svg className="w-5 h-5" fill='currentColor' aria-hidden="true" viewBox="0 0 24 24" data-testid="VisibilityIcon"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
                            </button>
                          </div>

                          <input type={passwordType} name="password" id="password" placeholder="••••••••" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPassword(e.target.value) }  value={password}  required={true}/>
                          <label className='text-left'>{passwordError}</label>
                      </div>
                      <div className='flex flex-col space-y-4 '>
                        <button onClick={e=>submitType('login')} type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Sign in</button>
                        
                        <button onClick={e=>submitType('signup')} type="submit" className="w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-3.5 text-center dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800 dark:text-white dark:border-black dark:hover:border-slate-500">Sign up</button>
                        {/* <p className="text-sm  font-medium text-gray-500 dark:text-gray-400">
                      Don't have an Account? <button onClick={e=>submitType('signup')} type="submit" className="font-bold text-primary-600 hover:underline dark:text-primary-700">Sign up</button>
                      </p> */}
                        <p className='font-bold dark:text-white'>
                          Or Continue with
                        </p>
                        {/* <button onClick={e=>submitType('google')} className=" w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                          <img className='w-5 float-left' alt='google icon' src={Google}/>
                          Continue with Google</button> */}
                          
                      </div>
                      
                      <div className='grid grid-flow-col  gap-4 mx-auto'>
                        {/* <GoogleLogin
                            shape='circle'
                            size='medium'
                            onSuccess={handleLogin}
                            onError={() => {
                              console.log('Login Failed');
                            }}
                            native_callback={e=>{
                              console.log(e)
                            }}
                          /> */}
                          {/* <button onClick={e=>submitType('signup')} type="submit" className="w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Sign up</button> */}

                          <button type="button" onClick={e=>googleLogin()} className=" w-full rounded-full text-dark bg-white hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-3.5 text-center dark:text-black dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800  dark:text-white dark:border-black dark:hover:border-slate-500">
                          <img className='w-5 float-left mr-3' alt='google icon' src={Google}/>
                           Google</button>

                          <button type="button" onClick={e=>appleLogin()} className=" w-full rounded-full text-white bg-black hover:bg-gray-800 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-3.5  text-center dark:border-black dark:hover:border-slate-500">
                          <img className='w-5 float-left mr-3' alt='apple icon' src={Apple}/>
                           Apple</button>
                          
                      </div>
                      <div className="pt-2 mx-10">
                        <p className="text-sm text-center font-medium text-gray-500 dark:text-gray-400 pt- ">
                        By signing in / up you agree to <button type="button" onClick={e=>setOpenTerms(true)} className="dark:text-white font-bold text-primary-600 hover:underline dark:text-primary-700">End User License Agreement </button> & <a className="dark:text-white font-bold text-primary-600 hover:underline dark:text-primary-700" href="https://wherespoppin.com/privacy-policy"> Privacy Policy</a>
                        </p>
                      </div>

                      <p className="text-sm font-medium text-gray-500 dark:text-gray-400 pt-4 ">
                      Can't Login? <NavLink to="/reset-password" className="font-bold text-primary-600 hover:underline dark:text-primary-700 dark:text-white">Reset password</NavLink>
                      </p>
                  </form>
              </div>
            </div>
            {/* <MenuItem /> */}<br></br>
          </div>

          <Dialog open={openTerms} onClose={setOpenTerms} className="relative z-20 ">
                      <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                      />
          
                      <div className="fixed inset-0 z-10 w-screen overflow-y-auto ">
                        <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                          <DialogPanel
                            transition
                            className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:dark:bg-gray-800 dark:text-white"
                          >
                            <div className="text-dark w-15 h-15 rounded-full absolute end-0 flex z-20 p-2 mr-2">
                                  <button  type="button" onClick={e=>setOpenTerms(false)} className="relative w-max items-center justify-items-center py-2 px-3.5 bg-yellow-800  text-xs font-medium text-white focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-black dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 ">  
                                    close
                                  </button>
                                </div>

                            <div className="space-y-4 p-6 w-full dark:bg-dark">
                                    <div className='pt-2 px-2  text-left mt-2'>
                                      <h1 className='text-lg font-bold'> END USER LINCENSE AGREEMENT (EULA)</h1>
                                      <p className='text-md font- '>WheresPoppin - <span className='font-bold'>Parkworth Company Limited</span> </p>
                                    </div>
                                    <hr></hr>
                                    <div className='pt-2 px-2  text-left mt-2'>
                                      <p className='text-sm font-bold mb-2'>End User Agreement (EULA) for WheresPoppin</p>
                                      <span className='text-sm font-bold mb-2'>Effective Date: </span><span className='font-'>01.04.2025</span>

                                      <div className='font-base my-4'>
                                        <p><span className='font-bold'>IMPORTATION:</span> Please read this End User License Agreement ("Agreement") carefully before downloading, installing, or using <span className='font-bold'>WheresPoppin </span>(the "App"). By downloading, installing, or using the App, you agree to be bound by the terms of this Agreement. If you do not agree, do not download, install, or use the App.</p>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>1. License Grant</p>
                                        <p><span className='font-bold'>WheresPoppin</span> grants you a revocable, non-exclusive, non-transferable, limited license to download, install, and use the App strictly in accordance with this Agreement and applicable laws in your jurisdiction.</p>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>2. Restrictions</p>
                                        <p className='mb-2'>You agree not to: </p>
                                        <ul className='ml-5 pl-3' style={{listStyleType: 'disc'}}>
                                          <li> Copy, modify, or distribute the App for any purpose.</li>
                                          <li> Reverse-engineer, decompile, or disassemble the App.</li>
                                          <li> Rent, lease, lend, sell, or sublicense the App.</li>
                                          <li> Use the App for any unlawful purposes or in violation of local, national, or international laws.</li>
                                          <li> Use the App to harm or abuse users on the platform.</li>
                                          <li className='font-bold text-color-red'> NB: All objectionable contents are deleted withing 24 hours and after been reported on the count of 2, your account will be suspended until further notice. </li>
                                          
                                        </ul>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>3. Ownership</p>
                                        <p>All intellectual property rights in the App, including but not limited to trademarks, copyrights, and patents, are owned by <span className='font-bold'>Parkworth Company Limited</span>. This Agreement does not transfer any ownership rights to you.</p>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>4. Updates and Modifications</p>
                                        <p>The App may automatically download and install updates, patches, or enhancements to improve functionality. By using the App, you consent to such updates. [App Developer/Company] reserves the right to modify or discontinue the App at any time without notice.</p>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>5. Data Privacy and Compliance</p>
                                        <p className='mb-2'>Your use of the App is subject to our Privacy Policy, which complies with the following data protection regulations: </p>
                                        <ul className='ml-5 pl-3' style={{listStyleType: 'disc'}}>
                                          <li> <span className='font-bold'>United States:</span> California Consumer Privacy Act (CCPA), Health Insurance Portability and Accountability Act (HIPAA) (if applicable).</li>
                                          <li> <span className='font-bold'>Europe:</span> General Data Protection Regulation (GDPR)</li>
                                          <li> <span className='font-bold'>Africa:</span> Local data privacy laws such as South Africa's Protection of Personal Information Act (POPIA).</li>
                                          <li> <span className='font-bold'>Asia:</span> Jurisdiction-specific regulations, including India's IT Act or Singapore's PDPA.</li>
                                          <li> <span className='font-bold'>Australia:</span> Australian Privacy Act. </li>
                                          
                                        </ul>
                                        <p className='mt-2'><span className='font-bold'>Parkworth Company Limited</span> is committed to complying with these and other local privacy laws. Refer to our full Privacy Policy at <a className='font-bold' href="https://wherespoppin.com/privacy-policy">https://wherespoppin.com/privacy-policy</a>  </p>
                                      </div>
                                      <hr></hr>

                                      <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>6. Regional Governing Lawse</p>
                                        <p className='mb-2'>This Agreement is subject to the governing laws of the region in which the user resides, as follows: </p>
                                        <ul className='ml-5 pl-3' style={{listStyleType: 'disc'}}>
                                          <li> <span className='font-bold'>North America:</span> Laws of the United States.</li>
                                          <li> <span className='font-bold'>Europe:</span> EU laws and individual member state laws</li>
                                          <li> <span className='font-bold'>Africa:</span> Laws of the specific country, including local jurisdictions.</li>
                                          <li> <span className='font-bold'>Asia:</span> Laws of the specific country, including GDPR-style frameworks where applicable.</li>
                                          <li> <span className='font-bold'>Australia:</span> Laws of Australia, including consumer protection laws. </li>
                                          
                                        </ul>
                                        <p className='mt-2'>In the event of a conflict, this Agreement shall defer to the most stringent applicable legal requirements to ensure compliance. </p>
                                      </div>
                                      <hr></hr>
                                    </div>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>7. Termination</p>
                                        <p>This Agreement is effective until terminated. Your rights under this Agreement will terminate immediately if you fail to comply with any term or applicable laws. Upon termination, you must stop using the App and delete all copies.</p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>8. Disclaimer of Warranties</p>
                                        <p>The App is provided "AS IS," without warranties of any kind, express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>9. Limitation of Liability</p>
                                        <p>To the fullest extent permitted by law <span className='font-bold'>Parkworth Company Limited</span> shall not be liable for any damages arising out of your use or inability to use the App, including direct, indirect, incidental, or consequential damages.</p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>10. Export Controls</p>
                                        <p>You agree to comply with all applicable export and import laws and regulations when using the App. The App may not be used, exported, or re-exported in violation of U.S., EU, or international export control laws.</p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>11. Dispute Resolution</p>
                                        <p className='mb-2'>Any disputes arising under this Agreement shall be resolved as follows: </p>
                                        <ul className='ml-5 pl-3' style={{listStyleType: 'disc'}}>
                                          <li> For users in the United States: Binding arbitration under U.S. laws.</li>
                                          <li> For users in the EU: Arbitration or courts of the user's country of residence under EU law.</li>
                                          <li> For users in other regions: Arbitration under the local governing laws.</li>
                                        </ul>
                                        <p className='mt-2'>In cases of irreconcilable jurisdictional conflict, disputes will be resolved under the United Nations Convention on Contracts for the International Sale of Goods (CISG). </p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>12. Amendments to this Agreement</p>
                                        <p> <span className='font-bold'>Parkworth Company Limited</span> reserves the right to modify this Agreement at any time. Continued use of the App constitutes acceptance of any changes.</p>
                                    </div>
                                    <hr></hr>

                                    <div className='font-base my-4'>
                                        <p className='text-md font-bold mb-2'>13. Contact Information</p>
                                        <p className='my-2'> For questions or concerns about this Agreement, please contact us:</p>
                                        <p className='font-medium mb-2'> Parkworth Company Limited.</p>
                                        <a className='font-medium' href='mailto:support@wherespoppin.app'> support@wherespoppin.app </a>
                                        <a className='font-medium' href='https://www.wherespoppin.com'> https://www.wherespoppin.com </a>
                                    </div>
                                    <hr></hr>
                                    
                                    <p className='text-md font-bold mb-2'>By downloading, installing, or using the App, you confirm that you have read and agree to be bound by the terms of this Agreement, including its compliance with global laws and regulations.</p>
                              </div>
                          </DialogPanel>
                        </div>
                      </div>
                    </Dialog>
          
        </section>
    );
  }
  

  export default Login;
  

